import React from "react";
import Text from "shared/ui/typography/Text";

const customerServiceEmail = "klantenservice@gewoongers.nl";
const customerServicePhoneNumber = "010 307 28 89";

const ContactCustomerService: React.FC = () => {
  return (
    <Text className="gg-grid gg-gap-y-2">
      <p>
        Oeps, er gaat iets mis! Neem contact op met onze klantenservice, dan
        kijken we even met je mee.
      </p>
      <p>
        <a
          href={`mailto:${customerServiceEmail}`}
          className="gg-font-bold gg-mr-5"
        >
          {customerServiceEmail}
        </a>

        <a
          href={`mailto:${customerServicePhoneNumber}`}
          className="gg-font-bold"
        >
          {customerServicePhoneNumber}
        </a>
      </p>
    </Text>
  );
};

export default ContactCustomerService;
